import { getStaticImageSrc } from '#/utils/getImageSrc';

// We have to use functions because the config is not always set at
// this point, because it's global scope.
export const ActionOppsIconSrcByName = {
  nycparks: (imagesPath: string) =>
    getStaticImageSrc('icons/action-opps/action-opps-nycparks.svg', imagesPath),
  golden: (imagesPath: string) =>
    getStaticImageSrc('icons/action-opps/action-opps-golden.png', imagesPath),
} as const;
